import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

interface NavigationHistory {
  getPreviousNonSettingsPath: () => string;
}

export const useNavigationHistory = (): NavigationHistory => {
  const location = useLocation();
  const historyRef = useRef<string[]>([]);
  const currentLocationRef = useRef(
    `${location.pathname}${location.search}${location.hash}`,
  );

  useEffect(() => {
    const currentLocation = `${location.pathname}${location.search}${location.hash}`;

    if (currentLocationRef.current !== currentLocation) {
      historyRef.current.push(currentLocationRef.current);

      // Limit history size to prevent memory issues
      if (historyRef.current.length > 50) {
        historyRef.current.shift();
      }

      currentLocationRef.current = currentLocation;
    }
  }, [location.hash, location.pathname, location.search]);

  const getPreviousNonSettingsPath = () => {
    // Traverse history backwards to find first non-settings page
    for (let i = historyRef.current.length - 1; i >= 0; i--) {
      const path = historyRef.current[i];

      // Skip if it's a settings page
      const pathname = path.split(/[?#]/, 1)[0];
      if (!pathname.includes('/dashboard/settings/')) {
        return path;
      }
    }

    // Default fallback
    return '/dashboard';
  };

  return {
    getPreviousNonSettingsPath,
  };
};
